import { useQueryClient } from "@tanstack/react-query";
import { DeleteDialog } from "components";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import SmallDetails from "components/SmallDetails/SmallDetails";
import { extractorSessionListQueryKey } from "./useExtractorSessionCacheSync";
import moment from "moment";
import React from "react";

interface Props {
  item: server.dto.ExtractorSession
}

export const ExtractorSessionTitle = ({ item }: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const queryClient = useQueryClient();

  const onDelete = async () => {
    await window.CoreApi.Extractor.DeleteSession({ extractorSessionId: item.extractorSessionId });
    queryClient.invalidateQueries({ queryKey: extractorSessionListQueryKey });
  };

  return <div className="flex gap" title={`${item.lifeCycle} - session ${item.extractorSessionId}`}>
    <div className="grow1">
      {item.sourcePdfFileName ? <SmallDetails
        link={window.CoreApi.Extractor.DownloadSessionFile.absoluteUrl(item.extractorSessionId)}
        label={`${item.sourcePdfFileName}.pdf`}
        subLabel={`${RESX.File.UploadedBy} ${item.owner.fullName} ${moment.utc(item.createdUtc).fromNow()}`}
      /> : <SmallDetails
        label="Pasted text"
        subLabel={`${RESX.File.UploadedBy} ${item.owner.fullName} ${moment.utc(item.createdUtc).fromNow()}`}
      />}
    </div>
    <div className="flex gap align-center">
      <PhosphorTrashButton
        layout="in-square"
        onClick={() => setIsDeleting(true)}
      />
    </div>
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
  </div>
}